import React from 'react'
// import {} from './Layouts.style'

function Layouts() {
  return <div />
}

export default Layouts
